export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SET_SELECTED_DEALER_ID_MODAL_DATA = 'SET_SELECTED_DEALER_ID_MODAL_DATA';
